module.exports = __webpack_public_path__ + "img/ico-up-down-arrows-b.22d2cca2.svg";